const decryptUpload = () => import('./decryptUpload.vue')

const upload = {
  install: function (Vue) {
    Vue.component('decrypt-upload', decryptUpload)
  }
}
export default upload



// WEBPACK FOOTER //
// ./src/components/upload/index.js